import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './EntrepriseProfile.css';

const API_URL = import.meta.env.VITE_API_URL;

const EntrepriseProfile = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [formData, setFormData] = useState({
        nomEntreprise: '',
        typeEntreprise: '',
        nom: '',
        prenom: '',
        mail: '',
        numeroTelephone: '',
        adresse: '',
        region: '',
        ville: ''
    });

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${API_URL}/auth/profile`, {
                headers: {Authorization: `Bearer ${token}`}
            });
            setUser(response.data);
            setFormData({
                nomEntreprise: response.data.nomEntreprise || '',
                typeEntreprise: response.data.typeEntreprise || '',
                nom: response.data.nom || '',
                prenom: response.data.prenom || '',
                mail: response.data.mail || '',
                numeroTelephone: response.data.numeroTelephone || '',
                adresse: response.data.adresse || '',
                region: response.data.region || '',
                ville: response.data.ville || ''
            });
        } catch (error) {
            console.error('Erreur profil:', error);
            Swal.fire('Erreur', 'Impossible de charger le profil', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            // On assume qu'il y a un endpoint pour mettre à jour le profil
            await axios.put(`${API_URL}/auth/profile`, formData, {
                headers: {Authorization: `Bearer ${token}`}
            });
            Swal.fire('Succès', 'Profil mis à jour avec succès', 'success');
            setEditMode(false);
            fetchProfile();
        } catch (error) {
            console.error('Erreur maj profil:', error);
            Swal.fire('Erreur', 'Erreur lors de la mise à jour', 'error');
        }
    };

    if (loading) return <div>Chargement...</div>;

    return (
        <div className="entreprise-profile-container">
            <div className="profile-header">
                <div className="profile-banner"></div>
                <div className="profile-avatar-section">
                    <div className="profile-avatar">{formData.nomEntreprise.charAt(0)}</div>
                    <div className="profile-name-section">
                        <h1>{formData.nomEntreprise}</h1>
                        <p className="profile-type">{formData.typeEntreprise}</p>
                    </div>
                    <button
                        className={`edit-btn ${editMode ? 'cancel' : ''}`}
                        onClick={() => setEditMode(!editMode)}
                    >
                        {editMode ? 'Annuler' : 'Modifier le profil'}
                    </button>
                </div>
            </div>

            <div className="profile-content">
                <form onSubmit={handleSubmit} className="profile-form">
                    <div className="form-section">
                        <h3>Informations Entreprise</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Nom de l'entreprise</label>
                                <input
                                    type="text"
                                    name="nomEntreprise"
                                    value={formData.nomEntreprise}
                                    onChange={handleChange}
                                    disabled={!editMode}
                                />
                            </div>
                            <div className="form-group">
                                <label>Type d'entreprise</label>
                                <select
                                    name="typeEntreprise"
                                    value={formData.typeEntreprise}
                                    onChange={handleChange}
                                    disabled={!editMode}
                                >
                                    <option value="PME">PME</option>
                                    <option value="Start-up">Start-up</option>
                                    <option value="Grande entreprise">Grande entreprise</option>
                                    <option value="Association">Association</option>
                                    <option value="Autre">Autre</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className="form-section">
                        <h3>Contact Privilégié</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Nom</label>
                                <input type="text" name="nom" value={formData.nom} onChange={handleChange} disabled={!editMode} />
                            </div>
                            <div className="form-group">
                                <label>Prénom</label>
                                <input type="text" name="prenom" value={formData.prenom} onChange={handleChange} disabled={!editMode} />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input type="email" name="mail" value={formData.mail} onChange={handleChange} disabled={!editMode} />
                            </div>
                            <div className="form-group">
                                <label>Téléphone</label>
                                <input type="text" name="numeroTelephone" value={formData.numeroTelephone} onChange={handleChange} disabled={!editMode} />
                            </div>
                        </div>
                    </div>

                    <div className="form-section">
                        <h3>Localisation</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Adresse</label>
                                <input type="text" name="adresse" value={formData.adresse} onChange={handleChange} disabled={!editMode} />
                            </div>
                            <div className="form-group">
                                <label>Région</label>
                                <input type="text" name="region" value={formData.region} onChange={handleChange} disabled={!editMode} />
                            </div>
                            <div className="form-group">
                                <label>Ville</label>
                                <input type="text" name="ville" value={formData.ville} onChange={handleChange} disabled={!editMode} />
                            </div>
                        </div>
                    </div>

                    {editMode && (
                        <div className="form-actions">
                            <button type="submit" className="save-btn">Enregistrer les modifications</button>
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default EntrepriseProfile;
